<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 21a4 4 0 00-3 1.38l-11.09-5.54a4 4 0 000-1.68L22 9.62A4 4 0 1021 7a3.86 3.86 0 00.09.84L10 13.38a4 4 0 100 5.24l11.09 5.54A3.86 3.86 0 0021 25a4 4 0 104-4z"/></svg>